<template>
  <div class="after-sale">
    <navbar title="售后中心" left-text show-home></navbar>
    <div class="after-sale-wrapper">
      <div class="nav">
        <ul class="nav-list">
          <li class="nav-item" :class="{'current' : current == index }" v-for="(nav, index) in navList" :key="index">
            <button @click="switchTab(index)">{{nav}}</button>
          </li>
        </ul>
      </div>
      <div class="nav-container">
        <component :is="componentId"></component>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Navbar from '../components/NavBar'
import AllOrder from '../components/afterSaleStatus/AllOrder'
import InHandOrder from '../components/afterSaleStatus/InHandOrder'
import Records from '../components/afterSaleStatus/records'
export default {
  name: 'afterSale',
  components: {
    Navbar,
    AllOrder,
    InHandOrder,
    Records
  },
  data () {
    return {
      componentId: AllOrder,
      // current: 0,
      navList: ['全部订单', '处理中', '售后记录']
    }
  },
  watch: {
    current (newVal) {
      switch (newVal) {
        case 0:
          this.componentId = AllOrder
          return
        case 1:
          this.componentId = InHandOrder
          return
        case 2:
          this.componentId = Records
          return
        default:
          this.componentId = AllOrder
      }
    }
  },
  computed: {
    ...mapState('afterSale', [
      'current'
    ])
  },
  methods: {
    ...mapMutations('afterSale', [
      'afterSaleNavCurent'
    ]),
    switchTab (i) {
      this.afterSaleNavCurent(i)
    }
  }
}
</script>

<style lang="less" scoped>
.after-sale {
  padding-top: 1rem;
}
.nav{
  position: fixed;
  top: 0.88rem;
  left: 0;
  right: 0;
  font-size: @fz28;
  color: @base;
  z-index: 9;
  .nav-list {
    width: 100%;
    height: 0.88rem;
    background-color: #fff;
    .flex-between;
    .nav-item {
      height: 100%;
      button {
        height: 100%;
        padding: 0 0.4rem;
      }
    }
    .current {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        width: 0.8rem;
        height: 0.06rem;
        left: 50%;
        margin-left: -0.4rem;
        bottom: 0;
        background-color: #FF5172;
      }
    }
  }
}
</style>
